
import { i18nText } from '@/locales';

import { Component, Prop, Vue } from 'vue-property-decorator';
import FormGroup from '@/UI/components/common/form/FormGroup.vue';
import PageTitle from "@/UI/components/common/PageTitle.vue";

import moment from 'moment';

import {ServiceStore} from "@/store/modules/Services";
import {IServices, IServicesListItem} from "@/entity/services/services.types";

import VisitCreateForm from "@/form/visits/visitCreate";
import VisitGeneralForm from "@/form/visits/visitGeneral";

import { StoresStore } from '@/store/modules/Warehouse/Warehouse';
import { ProductsStore } from "@/store/modules/Warehouse/Products";
import { IProducts, IProductsItem, Products } from "@/entity/warehouse/Products/Products.types";
import { IWarehouse, IWarehouseItem } from '@/entity/warehouse/Warehouse.types';

import { ConsumableStore } from "@/store/modules/Consumables";
import { IConsumables, IConsumablesListItem } from "@/entity/consumables/consumables.types";

import VisitConsumablesForms from "@/UI/components/forms/visits/detail/VisitConsumablesForms.vue";


@Component({
    components: { FormGroup, PageTitle, VisitConsumablesForms },
    methods: { moment }
})
export default class VisitConsumables extends Vue {
    @Prop() form!:  VisitGeneralForm;

    consumables_data: any[] = [];
    targetConsumables: any[] = [];


    get service(): IServices | null {
        return ServiceStore.service;
    }

    get products(): Products | null {
        return ProductsStore.products
    }
    
    get stores(): IWarehouse | null {
      return StoresStore.warehouse;
    }

    get consumables(): IConsumables | null{
        return ConsumableStore.consumables;
    }
            
    async created(): Promise<void> {

        await ConsumableStore.fetchAll();
        if(this.consumables){
            console.clear();
            console.log(i18nText("РАСХОДНИКИ"));
            this.targetConsumables = [];
            this.targetConsumables = this.consumables.data;

            this.form.setConsumablesData(this.targetConsumables);
            console.log(this.form);
        }
        // console.log('form');
        // console.log(this.form);

        await ServiceStore.fetchAll({filter: {salon_id: this.form.salon_id}});

         await StoresStore.fetchAll()
            if(this.stores){
                // console.log('СКЛАДЫ');
                // console.log(StoresStore.warehouse!.data.filter(e => e.type_id == 1));
            }

        await ProductsStore.fetchAll()
            if(this.products){
                // console.log('ПРОДКУТЫ');
                // console.log(this.products);
            }
            // console.log('forma -> ' );
            // console.log(this.form);
    }
}
